module.exports = __webpack_public_path__ + "img/Vector.7b2a3986.svg";